import React from 'react';
import { FaMapMarkerAlt, FaPencilRuler } from 'react-icons/fa';

const PopularCollectionCard = ({data}) => {

    

    const { image, name, price, location, use } = data;

    console.log(`popular collection data is :`, image, name, price, location, use);

    return (
        <div className="card w-96 bg-base-100 border">
        <div className="">
          <img
            src={image}
            alt="CollectionCarImage"
            className="object-cover h-72"
          />
        </div>
  
        <div className="p-3">
          <h2 className="text-[#0b163f] font-bold text-2xl pt-3">{name}</h2>
          <p className="text-xl my-3">
            <span className="text-primary font-semibold">${price}</span>/month
          </p>
          <div className="my-3">
            <p className="mb-2 flex items-center text-[#333] text-sm">
              <FaMapMarkerAlt /> <span className="mx-2 ">Location: </span>
              {location}
            </p>
  
            <p className="flex items-center text-[#333] text-sm">
              <FaPencilRuler /> <span className="mx-2 ">Years of Use: </span>
              {use}
            </p>
          </div>
          
        </div>
      </div>
    );
};

export default PopularCollectionCard;